module.exports = __webpack_public_path__ + "img/icon_assistant_camera.35ba712c.svg";